import React, { useEffect } from 'react';

type Props = {
  open: boolean;
  kind: 'project' | 'routine';
  onCancel: () => void;
  onConfirm: () => void;
};

const AssignmentRecordDeleteConfirm: React.FC<Props> = ({
  open,
  kind,
  onCancel,
  onConfirm,
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        onCancel();
      }
    };
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [open, onCancel]);

  if (!open) return null;

  const desc =
    kind === 'project'
      ? '제거한 하위 과제와 배정에서 뺀 멤버의 상태 기록이 모든 그룹에서 삭제되고, 완료 보상도 다시 계산됩니다. 삭제된 기록은 복구할 수 없습니다.'
      : '스케줄에서 빠진 날짜와 배정에서 뺀 멤버의 상태 기록이 모든 그룹에서 삭제되고, 완료 보상도 다시 계산됩니다. 삭제된 기록은 복구할 수 없습니다.';

  return (
    <div
      className="cp-pin-confirm-overlay"
      role="presentation"
      onClick={onCancel}
    >
      <div
        className="cp-pin-confirm cp-pin-confirm--warn"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-apn-record-delete-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cp-pin-confirm-warn-icon" aria-hidden>
          !
        </div>
        <p id="cp-apn-record-delete-title" className="cp-pin-confirm-warn-title">
          기록된 데이터가 삭제됩니다
        </p>
        <p className="cp-pin-confirm-warn-desc">{desc}</p>
        <div className="cp-pin-confirm-actions cp-pin-confirm-actions--split">
          <button
            type="button"
            className="cp-pin-modal-btn cp-pin-modal-btn--secondary"
            onClick={onCancel}
          >
            취소
          </button>
          <button
            type="button"
            className="cp-pin-modal-btn cp-pin-modal-btn--primary"
            onClick={onConfirm}
          >
            저장
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignmentRecordDeleteConfirm;
